var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFind = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 11.5h-.79l-.28-.27A6.471 6.471 0 0 0 13 7a6.5 6.5 0 1 0-6.5 6.5c1.61 0 3.09-.59 4.23-1.57l.27.28V13l5 4.99 1.49-1.49-4.99-5Zm-6 0C4.01 11.5 2 9.49 2 7s2.01-4.5 4.5-4.5S11 4.51 11 7s-2.01 4.5-4.5 4.5Z",
  fill: "#666"
})));

export default SvgFind;